export var QuestionTypesNames;
(function (QuestionTypesNames) {
    QuestionTypesNames["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE_TYPE";
    QuestionTypesNames["PAIRING"] = "PAIRING_TYPE";
    QuestionTypesNames["ESSAY"] = "ESSAY_TYPE";
    QuestionTypesNames["SHORT_ANSWER"] = "SHORT_ANSWER_TYPE";
    QuestionTypesNames["TRUE_FALSE"] = "TRUE_FALSE_TYPE";
    QuestionTypesNames["AUDIO"] = "AUDIO_TYPE";
    QuestionTypesNames["FILL_BLANKS"] = "FILL_BLANKS_TYPE";
    QuestionTypesNames["MIDDLE_SCREEN"] = "MIDDLE_SCREEN_TYPE";
})(QuestionTypesNames || (QuestionTypesNames = {}));
